export default {"src":"/gb/en/_next/static/media/CASS_logo.8ed28ee8.svg","height":56,"width":123,"blurWidth":0,"blurHeight":0};